import PropTypes from "prop-types";
import React from "react";

export default function GoogleForms({ block }) {
  const blockData = block.getData();

  const spreadsheetUrl = blockData.get("src");
  const width = blockData.get("width");
  const height = blockData.get("height");

  return (
    <div
      css={{
        paddingTop: 20,
        paddingBottom: 0,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <iframe
        src={spreadsheetUrl}
        frameBorder="0"
        css={{
          width: "100%",
          height: 436,
        }}
        style={{
          width,
          height,
        }}
      />
    </div>
  );
}

GoogleForms.propTypes = {
  block: PropTypes.object.isRequired,
};
